import { React, ts, useSelector } from '_core';

import Chart from './chart';
import Form from './form';
import { DraftParams, Params } from './types';

type SignalPreviewEntireUniverseProps = {
  id: string;
  mode: ts.enums.CHART_MODE_ENUM;
  params: Params | DraftParams;
  setParams: (_p: DraftParams) => void;

  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  widgetPaths?: Record<'main_data', string>;
  goFullScreen?: (_q: string) => void;
  fullScreen?: boolean;

  context?: ts.types.signal.SignalAnalysisContext;
  queryParams?: { initial?: string };
};

const SignalPreviewEntireUniverse = ({
  id,
  loadWidgetData,
  widgetPaths,
  mode,
  context,
  params,
  setParams,
  fullScreen,
  goFullScreen,
  queryParams,
}: SignalPreviewEntireUniverseProps) => {
  const universes = useSelector((state) => state.resources.universes);
  const currUniverse = universes.find((u) => u.id === context?.universe_id);

  const renderJobComponent = () => (
    <>
      <Chart
        id={id}
        loadWidgetData={loadWidgetData}
        file={widgetPaths['main_data']}
        fullScreen={fullScreen}
        context={context}
        params={params as Params}
        setParams={setParams}
        queryParams={queryParams}
        goFullScreen={goFullScreen}
      />
    </>
  );

  return (
    <>
      {mode == 'edit' ? (
        <Form
          params={params}
          setParams={setParams}
          startDate={context?.start_date}
          endDate={context?.end_date}
          universeCountries={currUniverse?.definition?.quotation_countries}
        />
      ) : (
        renderJobComponent()
      )}
    </>
  );
};

export default SignalPreviewEntireUniverse;
